function GET_FOOTER_HEIGHT() {
  return document.querySelector('footer').getBoundingClientRect().height;
}

export function SET_FOOTER_HEIGHT() {
  document.body.style.setProperty('--footer-height', `${GET_FOOTER_HEIGHT()}px`);
}
